import { Tenant } from '@/types'
import { request } from '@/store/client'

/**
  Marks the user as logged out with AuthX
* */
export const logoutFromAuthX = async (token: string): Promise<Tenant> => {
  if (!token) {
    throw new Error('TokenRequired')
  }

  const response = await request({
    url: '/logout',
    method: 'post',
    data: { token },
  })

  return response.data as Tenant
}
